import { RootState } from '@reducers';

export const selectBillingDetails = (state: RootState) => state.userDashboardRouteReducer.billingDetailsReducer;
